import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PropertyActions, {
  PropertySelectors,
  PROPERTY_STEPS
} from '@redux/PropertyRedux';

import { PropertyBasicForm, PropertyMoreInfoForm } from './forms';

import PricingDetails from './PricingDetails';

function PropertyEdit(props) {
  const { currentStep, propertyId } = props;

  if (currentStep === PROPERTY_STEPS.BASIC_INFO) {
    return <PropertyBasicForm propertyId={propertyId} />;
  } else if (currentStep === PROPERTY_STEPS.MORE_INFO) {
    return <PropertyMoreInfoForm propertyId={propertyId} />;
  } else if (currentStep === PROPERTY_STEPS.PRICING) {
    return <PricingDetails />;
  }

  return <div>Oops, invalid option</div>;
}

PropertyEdit.propTypes = {
  currentStep: PropTypes.number,
  setStep: PropTypes.func,
  propertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const mapStateToProps = state => ({
  currentStep: PropertySelectors.selectCurrentStep(state)
});

const mapDispatchToProps = dispatch => ({
  setStep: step => {
    dispatch(PropertyActions.setPropertyStep(step));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyEdit);
